<template>
  <div class="header">

    <div class="logo">
      <p id="logo"><img src="@/assets/diamond.png" alt=""></p>
      <span>Agent</span>
      <!-- <span>{{isApp }}</span> -->
      <i class="el-icon-s-operation header-icon" @click="handleMobile"></i>
    </div>
    <div class="logout">
      <div>
        <el-dropdown @command="handleCommand">
          <div class="dropdown el-dropdown-link">
            <img width="40px" src="https://coderthemes.com/hyper/creative/assets/images/users/avatar-1.jpg" alt="">
            <span>{{getStateusername}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">logout</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/bus.js";
export default {
  data() {
    return {
      isApp: "Dream",
      getStateusername: localStorage.username,
      index: 0,
    };
  },
  methods: {
    handleSelect() {},
    handleMobile() {
      this.index++;
      bus.$emit("mobileShow", this.index);
    },
    handleCommand(command) {
      this.$http.fetchget(this.$api.logout).then((res) => {
        if (res.code == 0) {
          localStorage.clear();
          let t = new Date(new Date().getTime() + 100);
          document.cookie = "user=new; expires=" + t.toGMTString();
          this.$router.push("/");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@function rem($size, $rem: 37.5) {
  @return $size / $rem + rem;
}
.header {
  padding: 0 40px;
  box-sizing: border-box;
  background: #3a434e;
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  .logo {
    width: 140px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .header-icon {
      display: none;
    }
    p {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
    }
    img {
      width: 20px;
    }
    span {
      font-family: "微软雅黑";
      font-size: 20px;
      color: #fff;
      font-weight: 1000;
      margin-left: 10px;
    }
  }
  .logout {
    background: #3c4655;
    height: 100%;
    display: flex;
    align-items: center;
    .dropdown {
      display: inline-block;
      display: flex;
      align-items: center;
      img {
        border-radius: 50%;
        display: inline-block;
      }
      span {
        margin: 0 0 0 10px;
      }
    }
  }
}
@media screen and (max-width: 680px) {
  .header {
    padding: 0 rem(20);
    .logo {
      width: rem(140);
      height: rem(80);
      .header-icon {
        font-size: rem(22);
        display: block;
        margin-left: rem(10);
      }
      p {
        width: rem(30);
        height: rem(30);
      }
      img {
        width: rem(20);
      }
      span {
        font-size: rem(20);
        margin-left: rem(10);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/header.vue